/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { white, text } = colors;
const { size } = typography.size ? typography : { size: {} };
const { borderRadius } = borders;
const { md } = boxShadows;

const contained = {
  styleOverrides: {
    root: {
      minHeight: pxToRem(37),
      padding: `${pxToRem(9)} ${pxToRem(24)}`,
      fontSize: size?.sm || pxToRem(14),
      fontWeight: 500,
      textTransform: "uppercase",
      lineHeight: 1.5,
      borderRadius: borderRadius.md,
      boxShadow: md,
      color: white.main,

      "&:hover": {
        boxShadow: "none",
      },

      "&:disabled": {
        color: text.disabled,
        backgroundColor: "#E0E0E0",
      },
    },
  },
};

export default contained;
